module.exports = ".row{\r\n    padding:20px 0px 0px;\r\n}\r\n\r\n.row:nth-child(odd){\r\nbackground: #f2f2f2;\r\n}\r\n\r\n.font{\r\n    font-weight: 600;\r\n}\r\n\r\n.mandatory{\r\n    color:red;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/legal/advocate-payment/adv-pay-form/adv-pay-form.component.css
// module id = ./src/app/legal/advocate-payment/adv-pay-form/adv-pay-form.component.css
// module chunks = main